// extracted by mini-css-extract-plugin
export var container = "_w0-0";
export var table = "_w0-2";
export var tableWrapper = "_w0-1";